import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import $ from 'jquery';
import AclWhatsapp from './AclWhatsapp';
import InfobipWhatsapp from './InfobipWhatsApp';
import MetaWhatsapp from './MetaWhatsapp';
import PinnacleWhatsapp from './PinnacleWhatsApp';
import SinchWhatsapp from './SinchWhatsApp';
class WhatsAppTabSetting extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget/whatsapp";
            var path1 = window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/";
            if (currentPath === path || currentPath === path1) {
                $("#meta-whatsapp-tab").addClass('active');
            } else if (currentPath.includes("/whatsapp/infobip-whatsapp")) {
                $("#infobip-whatsapp-tab").addClass('active');
            } else if (currentPath.includes("/whatsapp/acl-whatsapp")) {
                $("#acl-whatsapp-tab").addClass('active');
            } else if (currentPath.includes("/whatsapp/pinnacle-whatsapp")) {
                $("#pinnacle-whatsapp-tab").addClass('active');
            } else if (currentPath.includes("/whatsapp/sinch-whatsapp")) {
                $("#sinch-whatsapp-tab").addClass('active');
            }

            $("#meta-whatsapp-tab,#acl-whatsapp-tab,#infobip-whatsapp-tab,#pinnacle-whatsapp-tab,#sinch-whatsapp-tab")
                .on("click", function () {
                    $("#meta-whatsapp-tab,#acl-whatsapp-tab,#infobip-whatsapp-tab,#pinnacle-whatsapp-tab,#sinch-whatsapp-tab")
                        .removeClass('active');
                    $(this).addClass('active')

                })
        })();
    }

    render() {
        return (

            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <div className="container-fluid" style={{ marginLeft: '0px' }} >
                        {/* Nav tabs */}
                        <div className="tab-class" style={{ marginLeft: '10px' }}>
                            <ul className="nav nav-tabs border-bottom navCluster">
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="meta-whatsapp-tab" >
                                        Meta Whatsapp
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/acl-whatsapp" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="acl-whatsapp-tab" >
                                        ACL Whatsapp
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/infobip-whatsapp" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="infobip-whatsapp-tab" >
                                        Infobip Whatsapp
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/pinnacle-whatsapp" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="pinnacle-whatsapp-tab" >
                                        Pinnacle Whatsapp
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/sinch-whatsapp" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="sinch-whatsapp-tab" >
                                        Sinch Whatsapp
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/pinnacle-whatsapp" component={PinnacleWhatsapp}></Route>
                    <Route path="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/sinch-whatsapp" component={SinchWhatsapp}></Route>
                    <Route path="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/infobip-whatsapp" component={InfobipWhatsapp}></Route>
                    <Route path="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp/acl-whatsapp" component={AclWhatsapp}></Route>
                    <Route path="/projectmgmt/test-and-deploy/DistributionWidget/whatsapp" component={MetaWhatsapp}></Route>
                </Switch>
            </div>

        );
    }
}
export default WhatsAppTabSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/whatsAppTabs/WhatsappTabSetting.js